<template functional>
    <div class="a-amount-info">
        {{ props.text }}
    </div>
</template>

<script>

export default {
    name: "AAmountInfo",
    props: {
        text: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>